import { PROYECT } from "services/api";
import { reportNotesTransferredTypes } from "redux/reducers/Reports/reportNotesTransferred/types";
import { saveAs } from 'file-saver';
import axios from "axios";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";
const { SET_REPORT_NOTES_TRANSFERRED_FILTERS } = reportNotesTransferredTypes


export const getReportNotesTransferredAction = ({startDate, endDate, station, isPdf = true}) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/reports/migrate-notes?start=${startDate}&end=${endDate}&idStation=${station.id}&pdf=${isPdf}`;
    const fileName = `Reporte_Notas_traspasadas_${station.name}_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`;

    dispatch(startRequestComp('loadingReportNotesTransferred'))
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth
    }
    try {
      const pdf = await axios(access)
      saveAs(pdf.data, fileName)
      dispatch(setSnackbar(`${isPdf ? 'PDF' : 'Excel'} Descargado con éxito`, "success"))
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)))
    } finally {
      dispatch(stopRequestComp('loadingReportNotesTransferred'))
    }
  }
}

export const setReportNotesTransferredFilters = (key = "", value) => {
  return {
    type: SET_REPORT_NOTES_TRANSFERRED_FILTERS,
    payload: { value, key }
  }
}
